/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Link Block for anchor link with smooth scroll
 *
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.12.0
 */

import React, { useCallback } from 'react';

import { LinkBlock } from '../index';
import { ILinkProps } from './LinkBlock';

export interface ILinkBlockAnchor extends ILinkProps {
    url: string;
}

const LinkBlockAnchor = (props: ILinkBlockAnchor) => {
    const { url, onClick, ...linkProps } = props;

    const onClickHandler = useCallback((e: React.MouseEvent) => {
        onClick?.(e);
        const id = url.slice(1);
        const anchorElement = document.getElementById(id);
        anchorElement?.scrollIntoView({
            behavior: 'smooth',
        });
    }, [onClick, url]);

    return (
        <LinkBlock {...linkProps} isExternalUrl target='_self' url={url} onClick={onClickHandler}/>
    );
};


export default LinkBlockAnchor;
